import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MsfSelect } from '@components/select/select';
import { MsfSelectPaginated } from '@components/select/paginated/select-paginated';
import { MsfTreeSelect } from '@components/tree-select/tree-select';
import { NotificationRecipientCatalog } from './notification-recipient-catalog';

@Component({
  selector: 'app-notification-recipient-picker',
  standalone: true,
  imports: [TranslateModule, MsfSelect, MsfSelectPaginated, MsfTreeSelect],
  templateUrl: './notification-recipient-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationRecipientPickerComponent {
  readonly catalog = inject(NotificationRecipientCatalog);
  readonly kind = input('');
  readonly entityId = input('');
  readonly roleName = input('');
  readonly entityIdChange = output<string>();
  readonly roleNameChange = output<string>();
}
